// mui
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
// types
import { ReportColumnDto } from 'src/api';
// constants
import { booleanAggregationModels } from '../constants/aggregation-model/boolean';

export function IsFeeColumn(index: number) {
  const column = {
    field: 'isFee',
    headerName: 'Is fee',
    description: 'Whether the price is a fee',
    type: 'boolean',
    width: 150,
    index,
    groupable: true,
    availableAggregationFunctions: booleanAggregationModels,
    headerAlign: 'center',
    renderCell: (params: any) => {
      if (params.value === true) {
        return <CheckIcon />;
      }
      if (params.value === false) {
        return <ClearIcon color="disabled" />;
      }
      return null;
    },
  } as ReportColumnDto<any, any, any>;
  return column;
}
